import type { DbWarning } from '@vaultsfyi/common'
import { isAfter, isBefore } from 'date-fns'

export function getVaultUnexpiredWarnings(warnings: DbWarning[]) {
  const currentDate = new Date()
  return warnings.filter(
    (warning) => isAfter(currentDate, new Date(warning.start)) && isBefore(currentDate, new Date(warning.end))
  )
}
